module.exports = __webpack_public_path__ + "img/bot1.17832b7c.jpeg";